import { useState, useEffect } from "react";
import { PlusOutlined as Plus24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/PlusOutlined";
import { MinusOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/MinusOutlined";
import { TertiaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./FreeFrom.module.scss";

type FreefromProps = {
  freeFrom: string[];
  initialItemsToShow: number;
};

function transformIngredientText(freeFromText: string) {
  return freeFromText.replace(/_/, " ");
}
export const FreeFrom = ({
  freeFrom: freefrom,
  initialItemsToShow = 10,
}: FreefromProps) => {
  const [isMobile, setIsMobile] = useState(false);
  const [visibleCount, setVisibleCount] = useState(initialItemsToShow);
  const totalItems = freefrom.length;
  const NumOfItemsToShow = initialItemsToShow;

  const showMore = () => {
    setVisibleCount(Math.min(visibleCount + NumOfItemsToShow, totalItems));
  };

  const showLess = () => {
    setVisibleCount(initialItemsToShow);
  };

  const displayedItems = isMobile ? freefrom.slice(0, visibleCount) : freefrom;
  const remainingItems = totalItems - visibleCount;

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 567);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);
  return (
    <div className={styles.freefrom}>
      <h2 className={styles.title}>Free from</h2>
      <ul className={styles.list}>
        {displayedItems.map((freeFrom, index) => (
          <li key={index} className={styles.listItem}>
            {transformIngredientText(freeFrom)}
          </li>
        ))}
      </ul>
      {isMobile && visibleCount < totalItems && (
        <TertiaryButton
          onClick={showMore}
          className={styles.button}
          IconComponent={Plus24PxOutlinedIcon}
          iconPositionRight
          small={true}
          data-testid="show-more:button"
        >
          <span>
            {`Show ${Math.min(remainingItems, NumOfItemsToShow)} more`}
          </span>
        </TertiaryButton>
      )}

      {isMobile && visibleCount > NumOfItemsToShow && (
        <TertiaryButton
          onClick={showLess}
          className={styles.button}
          IconComponent={MinusOutlined}
          iconPositionRight
          small={true}
          data-testid="show-less:button"
        >
          <span>Show Less</span>
        </TertiaryButton>
      )}
    </div>
  );
};
